module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-3-b3365c260a1eb4ab4e95781f38168ffc.png";